<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-2"
          primary-title
        >
          Setar Situação
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="situacao"
            :items="situacoesAtividade"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Situação"
            hide-details
            prepend-icon="description"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: ['value', 'atividade', 'loading'],
  data() {
    return {
      situacao: null
    }
  },
  methods: {
    ...mapMutations([
      'showNotification'
    ]),
    adiciona() {
      if (this.situacao) {
        if (this.atividade !== null) {
          this.atividade.IdSituacao = this.situacao.IdSituacao;
          this.atividade.Situacao = this.situacao.Descricao;
          this.$emit('setaSituacao', this.atividade);
          this.situacao = null;
        } else {
          this.$emit('setaSituacaoSelected', this.situacao);
          this.situacao = null;
        }
      } else {
        this.showNotification({ text: 'Informe a situação', status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(['situacoesAtividade'])
  }
}
</script>

<style>

</style>
